export const GET_LOCKER_LIST_REQUEST = 'GET_LOCKER_LIST_REQUEST';
export const GET_LOCKER_LIST_SUCCESS = 'GET_LOCKER_LIST_SUCCESS';
export const GET_LOCKER_LIST_FAILURE = 'GET_LOCKER_LIST_FAILURE';